<template>
  <section class="item">
    <div class="item-func reply-left">
      <div class="reply-title clearfix">
        <div class="reply-name">
          <span
            v-if="index !== 0"
            class="box-name"
          >{{ replyFromName }}</span>
          <span
            v-if="index !== 0"
            class="box-text"
          >{{ $t('回复') }}</span>
          <span class="box-name">{{ item.reply_name }}</span>
          <span class="box-text">:</span>
          <span
            class="reply-footer"
            v-html="formatContent(item.content)"
          />
        </div>
        <!-- <span class="handle-box">
                    <ul>
                        <li v-show="isShowDelete" @mouseleave="hideDeleteConfirm()">
                            <i class="icon-delete" @click="deleteItem()"><img src="../../../../static/image/icon-delete.png" alt=""></i>
                            <delete-dialog
                                v-show="isShowPop"
                                @cancle="hideDeleteConfirm"
                                @confirm="deleteItem"
                            ></delete-dialog>
                        </li>
                    </ul>
                </span> -->
      </div>
      <div>
        <div
          class="comment-time"
          v-html="timerHandler(item.ctime)"
        />
        <span
          v-show="isShowReply && !sameCreator"
          class="reply-btn"
          @click="replyComment(item)"
        >{{ $t('回复') }}</span>
        <span
          v-show="isShowDelete"
          class="reply-btn"
          @click="deleteItem()"
        >{{ $t('删除') }}</span>
      </div>
    </div>
    <!--        <div class="item-line"></div>-->
  </section>
</template>
<script>
import * as Util from 'js/util/util.js'
import store from 'store'
import DeleteDialog from './delete-dialog.vue'

export default {
  components: {
    DeleteDialog,
  },
  props: ['item', 'index'],
  data() {
    return {
      Util,
      isShowPop: false,
      // isShowDelete: true,
      isShowReply: true,
    }
  },
  computed: {
    isAdmin() {
      return store.getters.userInfo && store.getters.userInfo.role === 'admin'
    },
    isShowDelete() {
      return this.sameCreator || this.isAdmin
    },
    currentUser() {
      return store.getters.userInfo.user_name
    },
    sameCreator() {
      if (this.item.creatorInfo) {
        return this.item.creatorInfo.user_name === this.currentUser
      }
      return false
    },
    replyFromName() {
      if (this.item.creatorInfo) {
        return this.item.creatorInfo.user_name || this.currentUser
      }
      return this.currentUser
    },
  },
  methods: {
    formatContent(data) {
      const reg = /\@\S+/g
      let result = data.match(reg) || []
      result = result.map((v) => `<span style="color: #2C7DF1;cursor: pointer;">${v}</span>`)
      const text = data.split(reg)
      let contextReturn = ''
      for (let i = 0; i < text.length; i++) {
        contextReturn += text[i] + (result[i] || '')
      }
      return contextReturn
    },
    popDeleteConfirm() {
      this.isShowPop = true
    },
    hideDeleteConfirm() {
      this.isShowPop = false
    },
    deleteItem() {
      this.$emit('modifyComments', {
        type: 'delete',
        data: this.item,
      })
    },
    /**
         * 回复
         */
    replyComment(value) {
      console.log(value, '=============replyComment=============')
      this.$emit('replyComment', { ...value })
    },
    timerHandler(originTime) {
      return Util.timeago(originTime)
    },
  },
}
</script>
<style lang="less" scoped>
// @import '~less/reset.less';
.item-func{
  position: relative;
  min-height: 40px;
  font-size: 10px;
}
.comment-time {
  /*margin-top: 5px;*/
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: #929CA9;
  max-width: 172px;
  display: inline-block;
  vertical-align: bottom;
}
.reply-btn{
  display: inline-block;
  font-size: 12px;
  color: #1B2733;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 4px;
}
.handle-box {
  display: none;
  position: absolute;
  right: -24px;
  ul {
    margin-right: 40px;
    li{
      float: left;
    }
  }
}
.item-line {
  width: 100%;
  border-top: 1px solid #EAEAEA;
}
.item::after {
  content: "";
  clear: both;
  display: table;
}
// :hover
.item:hover {
  .handle-box{
    display: block;
    float: left;
    ul {
      width: 100%;
    }
    cursor: pointer;
  }
}
.box-name, .box-text {
  display: inline-block;
  float: left;
  height: 17px;
  font-size: 12px;
  line-height: 17px;
  max-width: 60px;
  width: auto;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /*cursor: pointer;*/
  color: #1B2733;
  margin-right: 2px;
}
.reply-name {
  display: inline-block;
  float: left;
  width:100%;
  min-height: 20px;
  font-size: 12px;
  line-height: 17px;
}
.reply-left {
  /*margin-left: 15px;*/
}
.reply-footer {
  color: #637282;
  font-size: 12px;
  line-height: 17px;
  margin-left: 0;
  word-break: break-all;
}
.delete-dialog {
  left: -180px;
  width: 200px;
}
</style>
